import config from '../../../../config';
import Request from '../../../Request';

export default function confirm(orderId, paymentMethodId, onSuccess, onFailure) {
  return Request.post(`${config.apiUrl}/orders/${orderId}/payment_intents/confirm`,
    { payment_method_id: paymentMethodId }, onSuccess, onFailure);
}